var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('TriggerTextFieldWithEdit', {
    attrs: {
      "api": `/api/triggers/${_vm.resultRow.id}`,
      "field": "description"
    },
    model: {
      value: _vm.resultRow.description,
      callback: function ($$v) {
        _vm.$set(_vm.resultRow, "description", $$v);
      },
      expression: "resultRow.description"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }